import React, { ReactElement, useContext, useState } from "react";
import { CartFlowContext, CartFlowState } from "@cart-client/contexts/CartFlowContext";
import { INTERNAL_CART_SOURCE } from "@cart-client/interfaces/Cart";
import { CheckoutContext } from "@swiggy-private/checkout-core";
import { getCartSource } from "@cart-client/components/cart-main/helpers";

const initialState: CartFlowState = {
    cartSource: INTERNAL_CART_SOURCE.DEFAULT_FOOD,
};

export function CartFlowContextProvider(props: { children: React.ReactNode }): ReactElement {
    const { checkoutState } = useContext(CheckoutContext);
    const [data, setData] = useState({
        ...initialState,
        cartSource: getCartSource(checkoutState),
    });

    const cartContextValue = React.useMemo(
        () => ({
            data,
            setData,
        }),
        [data],
    );

    return <CartFlowContext.Provider value={cartContextValue}>{props.children}</CartFlowContext.Provider>;
}
